import { Component } from 'react';
import { RefreshCw } from 'lucide-react';
import { reportClientError } from '../core/api';

// Root-level safety net: without this, one uncaught render error in any leaf
// component white-screens the entire session with no recovery path (React's
// own "consider adding an error boundary" console warning was going unheeded).
// Deliberately generic/app-wide - PreviewPane has its own narrower boundary
// for builder-preview-specific recovery (falls back to an inline note, not a
// full-page reload) and stays as-is.
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error(error, info);
    reportClientError(error, info, { boundary: 'app' });
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-neutral-50 dark:bg-neutral-950 px-4">
          <div className="max-w-sm w-full text-center">
            <p className="text-sm font-semibold text-neutral-900 dark:text-white">Something went wrong.</p>
            <p className="mt-1.5 text-sm text-muted dark:text-subtle">
              This screen hit an error it couldn&apos;t recover from. Reloading usually fixes it; your data is unaffected.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="mt-4 inline-flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 rounded-lg bg-neutral-900 dark:bg-white text-white dark:text-neutral-900 hover:opacity-90 transition-opacity"
            >
              <RefreshCw size={13} /> Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
